export default __webpack_public_path__ + "static/media/icons-system-logout-a.3f2d73de.svg";